module.exports = __webpack_public_path__ + "static/media/thumbnail.7278dada.jpg";